<template>
  <div class="auth-layout">
    <div class="container">
      <div class="content">
        <div class="auth-layout__left-side"></div>
        <div class="auth-layout__banner">
          <img src="~@/assets/img/auth-banner.png" alt="Auth banner" />
        </div>
        <div class="auth-layout__content">
          <div class="auth-layout__content-inner">
            <slot />
          </div>
        </div>
      </div>
      <footer-block class="footer"></footer-block>
    </div>

  </div>
</template>

<script>
import Footer from "@/components/app/Footer";
export default {
  name: "AuthLayout",
  components: { FooterBlock: Footer },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/_variables.scss";

.auth-layout {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  height: 100%;

  &__left-side {
    position: absolute;
    top: 0;
    left: 0;
    width: 50%;
    height: 92%;
    background-color: $lightBlue;
    z-index: 0;
  }

  .container {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;

    .content {
      height: 100%;
      width: 100%;
      display: flex;
      align-items: center;
    }
  }

  .footer {
    width: 100%;
  }

  &__banner {
    width: 50%;
    padding: 20px;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
      max-width: 517px;
    }
  }

  &__content {
    width: 50%;
    padding: 20px;

    &-inner {
      width: 100%;
      max-width: 425px;
      margin: 0 auto;
    }
  }
}
</style>